module.exports = __webpack_public_path__ + "img/banner_about.8f451a34.jpg";